import React, { useState, useEffect } from 'react';
import { HiChevronDown } from "react-icons/hi2";

function FilterPosts({ onFilter, resetToggle }) {
  const [filters, setFilters] = useState({
    company: '',
    status: '',
    role: '',
    type: '',
  });

  useEffect(() => {
    setFilters({ company: '', status: '', role: '', type: '' });
  }, [resetToggle]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  useEffect(() => {
    onFilter(filters);
  }, [filters, onFilter]);

  // Premium dropdown styling
  const selectClass = `
    appearance-none bg-white border border-slate-200 
    hover:border-blue-400 hover:bg-blue-50/40
    text-slate-700 text-sm font-bold 
    py-2 px-4 pr-10 rounded-xl 
    focus:outline-none focus:ring-4 focus:ring-blue-500/5 focus:border-blue-500 
    transition-all cursor-pointer w-full sm:w-auto
  `;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* Status Filter */}
      <div className="relative group">
        <select
          name="status"
          value={filters.status}
          onChange={handleFilterChange}
          className={selectClass}
        >
          <option value="">Status</option>
          <option value="Selected">Selected</option>
          <option value="Not Selected">Not Selected</option>
          <option value="">None</option>
        </select>
        <HiChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none group-hover:text-blue-500 transition-colors" size={14}/>
      </div>

      {/* Type Filter */}
      <div className="relative group">
        <select
          name="type"
          value={filters.type}
          onChange={handleFilterChange}
          className={selectClass}
        >
          <option value="">Type</option>
          <option value="Full Time">Full Time</option>
          <option value="Intern">Intern</option>
          <option value="">None</option>
        </select>
        <HiChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none group-hover:text-blue-500 transition-colors" size={14} />
      </div>
    </div>
  );
}

export default FilterPosts;